import { useAppSelector } from '@services/store'
import {
	REQUEST_TN_DETAILS_STEPS_NAME,
	requestCategories,
	requestSubCategories
} from '@services/constants'
import requestForm from '../request.form'
import * as utilsList from './__index.utils'

// --- 1. Initial state Hook ---
export function useInitialFilesState(filesInputs) {
	const answers = useAppSelector((state) => state.request.configs)
	const { pageAssets } = requestForm()

	const radioListYesNo = utilsList.radioListYesNo(pageAssets)

	return {
		// Procuration du propriétaire
		// Owner's power of attorney
		procurationInput: {
			name: 'procurationInput',
			label: pageAssets?.request_form_ownerPowerOfAttorney,
			labelKey: 'request_form_ownerPowerOfAttorney',
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'procurationInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'procurationInput')
					?.uploadedFilesMap || new Map()
			),
			description: '',
			required: answers?.isLocationOwned?.toString() == radioListYesNo[1].value,
			numberMaxFiles: 1,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_2,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.procuration
		},
		// Autorisation des administrateurs
		autorisationInput: {
			name: 'autorisationInput',
			label:
				pageAssets?.request_form_buildingDemolitionOrMovingPermit_adminAutorisation,
			labelKey:
				'request_form_buildingDemolitionOrMovingPermit_adminAutorisation',
			description: '',
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'autorisationInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'autorisationInput')
					?.uploadedFilesMap || new Map()
			),
			required:
				answers?.existingMainBuildingIsShared?.toString() ==
				radioListYesNo[0].value,
			numberMaxFiles: 1,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_3,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.procuration
		},

		// Plan d'implantation - Fait par un arpenteur-géomètre, nécessaire pour une plus grande emprise au sol
		// NEW Plan illustrant l’emplacement projeté d’une construction par rapport aux limites d'une propriété et selon les règlements en vigueur.
		planImplantationArpenteurGrandeEmpriseInput: {
			name: 'planImplantationArpenteurGrandeEmpriseInput',
			label:
				pageAssets?.request_form_urbanisme_implantationPlanArpenteurGrandeEmprise,
			labelKey: 'request_form_urbanisme_implantationPlanArpenteurGrandeEmprise',
			description:
				pageAssets?.request_form_urbanisme_implantationPlanArpenteurGrandeEmprise_description,
			files: new Set<File>(
				filesInputs?.find(
					(el) => el.name == 'planImplantationArpenteurGrandeEmpriseInput'
				)?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find(
					(el) => el.name == 'planImplantationArpenteurGrandeEmpriseInput'
				)?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planImplantationArpenteurGrandeEmprise,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan d'implantation 	Fait à la main, à partir du certificat de localisation
		// NEW Plan d'implantation (préparé par un arpenteur-géomètre ou par la personne requérante)
		planImplantationFaitMainInput: {
			name: 'planImplantationFaitMainInput',
			label: pageAssets?.request_form_urbanisme_implantationPlanFaitMain,
			labelKey: 'request_form_urbanisme_implantationPlanFaitMain',
			description:
				pageAssets?.request_form_urbanisme_implantationPlanFaitMain_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'planImplantationFaitMainInput')
					?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'planImplantationFaitMainInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planImplantationFaitMain,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan d'architecture préliminaire
		planArchitecturePreliminaireInput: {
			name: 'planArchitecturePreliminaireInput',
			label: pageAssets?.request_form_urbanisme_preliminaryArchitecturePlan,
			labelKey: 'request_form_urbanisme_preliminaryArchitecturePlan',
			description:
				pageAssets?.request_form_urbanisme_preliminaryArchitecturePlan_description,
			files: new Set<File>(
				filesInputs?.find(
					(el) => el.name == 'planArchitecturePreliminaireInput'
				)?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find(
					(el) => el.name == 'planArchitecturePreliminaireInput'
				)?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planArchitecturePreliminaire,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan d'aménagement
		planAmenagementInput: {
			name: 'planAmenagementInput',
			label: pageAssets?.request_form_urbanisme_developmentPlan,
			labelKey: 'request_form_urbanisme_developmentPlan',
			description:
				pageAssets?.request_form_urbanisme_developmentPlan_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'planAmenagementInput')?.files ||
					[]
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'planAmenagementInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planAmenagement,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan d'aménagement paysager (préliminaire)
		planAmenagementPaysagerPreliminaireInput: {
			name: 'planAmenagementPaysagerPreliminaireInput',
			label:
				pageAssets?.request_form_urbanisme_planAmenagementPaysagerPreliminaire,
			labelKey: 'request_form_urbanisme_planAmenagementPaysagerPreliminaire',
			description:
				pageAssets?.request_form_urbanisme_planAmenagementPaysagerPreliminaire_description,
			files: new Set<File>(
				filesInputs?.find(
					(el) => el.name == 'planAmenagementPaysagerPreliminaireInput'
				)?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find(
					(el) => el.name == 'planAmenagementPaysagerPreliminaireInput'
				)?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planAmenagementPaysagerPreliminaire,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Fiche Bâtiment/Fiche Technique*
		ficheBatimentInput: {
			name: 'ficheBatimentInput',
			label:
				pageAssets?.request_form_buildingConstructionOrAdditionPermit_buildingSheet,
			labelKey:
				'request_form_buildingConstructionOrAdditionPermit_buildingSheet',
			description: pageAssets?.request_form_buildingConstructionOrAdditionPermit_buildingSheet_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'ficheBatimentInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'ficheBatimentInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.ficheBatiment,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan d'architecture
		planArchitectureInput: {
			name: 'planArchitectureInput',
			label: pageAssets?.request_form_urbanisme_architecturePlan,
			labelKey: 'request_form_urbanisme_architecturePlan',
			description:
				pageAssets?.request_form_urbanisme_architecturePlan_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'planArchitectureInput')?.files ||
					[]
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'planArchitectureInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planArchitecture,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Certificat de localisation
		certificatDeLocalisationInput: {
			name: 'certificatDeLocalisationInput',
			label: pageAssets?.request_form_urbanisme_locationCertificate,
			labelKey: 'request_form_urbanisme_locationCertificate',
			description:
				pageAssets?.request_form_urbanisme_locationCertificate_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'certificatDeLocalisationInput')
					?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'certificatDeLocalisationInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.certificatDeLocalisation,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan de structure
		planStructureInput: {
			name: 'planStructureInput',
			label: pageAssets?.request_form_urbanisme_structuralPlan,
			labelKey: 'request_form_urbanisme_structuralPlan',
			description:
				pageAssets?.request_form_urbanisme_structuralPlan_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'planStructureInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'planStructureInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planStructure,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Étude acoustique
		etudeAcoustiqueInput: {
			name: 'etudeAcoustiqueInput',
			label: pageAssets?.request_form_urbanisme_acousticStudy,
			labelKey: 'request_form_urbanisme_acousticStudy',
			description: '',
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'etudeAcoustiqueInput')?.files ||
					[]
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'etudeAcoustiqueInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.etudeAcoustique,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Engagement - Exempt de contaminant
		engagementExemptDeContaminantInput: {
			name: 'engagementExemptDeContaminantInput',
			label: pageAssets?.request_form_urbanisme_engagementExemptDeContaminant,
			labelKey: 'request_form_urbanisme_engagementExemptDeContaminant',
			description: '',
			files: new Set<File>(
				filesInputs?.find(
					(el) => el.name == 'engagementExemptDeContaminantInput'
				)?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find(
					(el) => el.name == 'engagementExemptDeContaminantInput'
				)?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.engagementExemptContaminant,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan d'ingénieur
		planIngenieurInput: {
			name: 'planIngenieurInput',
			label: pageAssets?.request_form_urbanisme_engineerPlan,
			labelKey: 'request_form_urbanisme_engineerPlan',
			description: pageAssets?.request_form_urbanisme_engineerPlan_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'planIngenieurInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'planIngenieurInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planIngenieur,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},

		// Plan civil
		planCivilInput: {
			name: 'planCivilInput',
			label: pageAssets?.request_form_urbanisme_civilPlan,
			labelKey: 'request_form_urbanisme_civilPlan',
			description: pageAssets?.request_form_urbanisme_civilPlan_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'planCivilInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'planCivilInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.planCivil,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		},
		

		// Autres documents
		autresSiRequisInput: {
			name: 'autresSiRequisInput',
			label: pageAssets?.request_form_urbanisme_otherDocuments,
			labelKey: 'request_form_urbanisme_otherDocuments',
			description:
				pageAssets?.request_form_urbanisme_otherDocuments_description,
			files: new Set<File>(
				filesInputs?.find((el) => el.name == 'autresSiRequisInput')?.files || []
			),
			uploadedFilesMap: new Map<string, string>(
				filesInputs?.find((el) => el.name == 'autresSiRequisInput')
					?.uploadedFilesMap || new Map()
			),
			required: false,
			numberMaxFiles: 10,
			category: requestCategories.urbanisme,
			subCategory: requestSubCategories.autresSiRequis,
			subStep: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS,
			shouldValidateIn: REQUEST_TN_DETAILS_STEPS_NAME.DOCUMENTS
		}
	}
}

// --- 2. Logique de mise à jour des fichiers en fonction de la configuration des documents	 ---

function updateFilesByDocumentsConfig(state, documentStatusConfig) {
	type StateType = ReturnType<typeof useInitialFilesState>
	const updates: Partial<StateType> = { ...state }

	// Liste des inputs à exclure
	const excludedInputs = ['procurationInput', 'autorisationInput']

	// Supprimer les inputs exclus de updates
	excludedInputs.forEach((inputName) => {
		delete updates[inputName]
	})

	// Iterate over each file input and update its required status based on the documentStatusConfig
	Object.values(updates).forEach((fileInput) => {
		const { name } = fileInput

		updates[name] = {
			...fileInput,
			required: documentStatusConfig[name] == 'required' ? true : false
		}
	})

	return updates
}

// --- 3. Reducer centralisé ---
export const inputFilesReducer = (state, action) => {
	switch (action.type) {
		case 'UPDATE_FILES': {
			const { name, files } = action
			let newState = {
				...state,
				[name]: {
					...state[name],
					files: files
				}
			}

			return newState
		}
		case 'UPDATE_UPLOADED_FILES_MAP': {
			const { name, uploadedFilesMap } = action
			let newState = {
				...state,
				[name]: {
					...state[name],
					uploadedFilesMap: uploadedFilesMap
				}
			}

			return newState
		}
		case 'UPDATE_REQUIRED': {
			const { name, required } = action
			let newState = {
				...state,
				[name]: {
					...state[name],
					required: required
				}
			}

			return newState
		}
		case 'UPDATE_REQUIRED_BY_DOCUMENTS_CONFIG': {
			const { documentsStatusConfig } = action

			const updates = updateFilesByDocumentsConfig(state, documentsStatusConfig)

			return {
				...state,
				...updates
			}
		}
		case 'INITIALIZE_FILES_INPUTS_FROM_STORE': {
			const { newState } = action

			return newState
		}

		default:
			return state
	}
}
